"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _PushMessageCreation = require("@/api/messagePush/PushMessageCreation");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      queryData: {
        messagePlanConfigId: '',
        messageType: '',
        status: '',
        memberId: '',
        page: 1,
        size: 10
      },
      options: []
    };
  },
  created: function created() {
    this.listMessageRecord();
  },
  methods: {
    listMessageRecord: function () {
      var _listMessageRecord2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _PushMessageCreation.listMessageRecord)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                console.log('res', res);
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listMessageRecord() {
        return _listMessageRecord2.apply(this, arguments);
      }
      return listMessageRecord;
    }(),
    repeatMessageRecord: function () {
      var _repeatMessageRecord2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(messageRecordId) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                messageRecordId: messageRecordId
              };
              _context2.n = 1;
              return (0, _PushMessageCreation.repeatMessageRecord)(params);
            case 1:
              res = _context2.v;
              console.log(res);
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.listMessageRecord();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function repeatMessageRecord(_x) {
        return _repeatMessageRecord2.apply(this, arguments);
      }
      return repeatMessageRecord;
    }(),
    // 查询
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.listMessageRecord();
    },
    // 重置
    onInitialize: function onInitialize() {
      this.onInit();
      this.listMessageRecord();
    },
    onInit: function onInit() {
      this.queryData = {
        messagePlanConfigId: '',
        messageType: '',
        status: '',
        memberId: '',
        page: 1,
        size: 10
      };
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.listMessageRecord();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.listMessageRecord();
    },
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickName
        }
      });
    },
    onReissue: function onReissue(id) {
      this.repeatMessageRecord(id);
    }
  }
};